import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './chartSetup';
import { CHART_COLORS, defaultChartOptions } from './chartSetup';

const PALETTE = [
  CHART_COLORS.purple,
  CHART_COLORS.green,
  CHART_COLORS.amber,
  CHART_COLORS.rose,
  CHART_COLORS.cyan,
  CHART_COLORS.blue
];

const DonutChart = ({ labels = [], values = [], title }) => {
  const chartData = useMemo(() => ({
    labels,
    datasets: [{
      data: values,
      backgroundColor: labels.map((_, index) => PALETTE[index % PALETTE.length]),
      borderWidth: 2,
      borderColor: '#ffffff',
      hoverOffset: 6
    }]
  }), [labels, values]);

  const options = useMemo(() => ({
    ...defaultChartOptions,
    cutout: '65%',
    plugins: {
      ...defaultChartOptions.plugins,
      legend: {
        ...defaultChartOptions.plugins.legend,
        position: 'bottom'
      }
    }
  }), []);

  const total = values.reduce((sum, value) => sum + value, 0);

  if (!total) {
    return (
      <div className="h-56 flex items-center justify-center text-sm text-gray-500">
        No data available
      </div>
    );
  }

  return (
    <div>
      {title && <h3 className="text-base font-bold text-gray-900 mb-3">{title}</h3>}
      <div className="h-56 relative" role="img" aria-label={title || 'Donut chart'}>
        <Doughnut data={chartData} options={options} />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-2xl font-bold text-gray-900">{total.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
